<div class="dialog-header">
    <h2 mat-dialog-title>
        O que é o Resulth Local Connect?
    </h2>
    <div class="header-actions">
        <button mat-icon-button (click)="fechar()" tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content>
    <div class="info-section">
        <h3>A ponte tecnológica entre o seu negócio e a inovação</h3>
        <p>
            O Resulth Local Connect é a "ponte" tecnológica que conecta o seu banco de dados local e o mundo digital.
            Ao instalar esse recurso, você permite que o seu sistema Resulth converse em tempo real com o nosso Hub de
            inovações.
        </p>

        <h3>O que você ganha com ele ativo?</h3>
        <p>
            Com ele ativo, você ganha acesso a ferramentas poderosas como Inteligência Artificial no
            WhatsApp, integrações com a Zoppy, Scanntech e o novo Connect 2.0.
        </p>
        <p>
            Ele é a garantia de que seus dados estarão prontos para alimentar as tecnologias mais modernas do mercado,
            de forma segura e automática.
        </p>

        <hr style="margin: 24px 0; border: 0; border-top: 1px solid #e0e0e0; opacity: 0.5;">

        <h3>Como funciona?</h3>
        <ul>
            <li>
                <strong>Instalação local:</strong> Um serviço é instalado na mesma rede do seu banco de dados Resulth,
                garantindo a comunicação segura entre o sistema local e o Hub.
            </li>
            <li>
                <strong>Autenticação via Token:</strong> Um token exclusivo é gerado para cada empresa.
                Empresas de um mesmo grupo podem compartilhar o token da matriz para simplificar a gestão.
            </li>
            <li>
                <strong>Conexão com o banco de dados:</strong> Você configura os dados de acesso ao banco Firebird
                (host, porta, caminho, usuário e senha) para que o serviço possa consultar os dados necessários.
            </li>
            <li>
                <strong>Sincronização automática:</strong> Uma vez configurado e ativo, o sistema passa a sincronizar
                dados automaticamente, alimentando as integrações habilitadas no Hub.
            </li>
        </ul>

        <h3>Segurança</h3>
        <p>
            Toda a comunicação é feita utilizando tokens criptografados. A senha do banco de dados é armazenada de
            forma segura e nunca é exposta. Você pode regerar o token a qualquer momento, invalidando conexões antigas
            imediatamente.
        </p>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="pb-3 pr-3">
    <button mat-stroked-button (click)="fechar()">Entendi</button>
</mat-dialog-actions>
